import config from '../../lib/config'

import PageMixins from '../../components/_mixins/pages'
import {
  ValidationMixins,
  setValidationRule,
  parseValidationSetup,
  parseValidations,
  truthyRule,
  passwordRules,
  passwordConfirmationRules,
  emailConfirmationRules,
  phoneConfirmationRules,
} from '../../lib/validations'

// const { validationMixin, default: Vuelidate } = require('vuelidate')
import ProviderService from '../../services/provider'
import MainService from '../../services/main'

import {now, DateTime, Settings} from '../../lib/dates'
import {countries, states, get$} from '../../lib/utils'
Settings.defaultLocale = "en-us"

import {Datetime} from 'vue-datetime-extended'
import 'vue-datetime-extended/dist/vue-datetime-extended.css'

const EventBus = window.VueEventBus

const defaultContent = {
  subscribe: {
    label: 'By registering with us you are opting-in to receive news and ' +
      'special offers from Supercharged Entertainment. ' +
      'To change your email preferences, visit account profile.',
  },
  subscribeAlert: {
    title: 'Before continuing, consider staying connected!',
    message: 'Agree to receive our emails and texts for ' +
                'exclusive offers, VIP updates, and' +
                ' early access (sometimes created with a' +
                ' little help from AI). You can unsubscribe' +
                ' anytime, and standard message/data rates may apply.',
    buttons: {
      accept: {title: 'Accept and continue'},
      deny: {title: 'No, thank you'}
    },
  }
}

const validations = {
  first_name: setValidationRule('fields.first_name'),
  last_name: setValidationRule('fields.last_name'),
  email: setValidationRule('fields.email', {
    required: {error: 'Email is required.'},
    email: {error: 'Email is not valid.'},
  }),
  email_confirmation: setValidationRule('fields.email_confirmation', emailConfirmationRules),
  password: setValidationRule('fields.password', passwordRules),
  password_confirmation: setValidationRule('fields.password_confirmation', passwordConfirmationRules),
  birth_date: setValidationRule('fields.birth_date'),
  address: setValidationRule('fields.address', 'Address'),
  city: setValidationRule('fields.city'),
  state: setValidationRule('fields.state'),
  zip: setValidationRule('fields.zip'),
  country: setValidationRule('fields.country'),
  phone: setValidationRule('fields.phone', {
    required: {error: 'Mobile phone is required.'},
  }),
  phone_confirmation: setValidationRule('fields.phone_confirmation', phoneConfirmationRules),
  terms: setValidationRule('fields.terms', {
    truthy: {error: 'Agree to the Terms of Service and Privacy Policy.', rule: truthyRule},
  }),
  sms_subscribe: {},
  subscribe: {},
}

export default {
  name: 'page-raceway-registration',
  settings: 'page.registration',
  translations: 'page.registration',
  mixins: [PageMixins, ValidationMixins],
  components: {Datetime},
  props: {
    enableTerms: {
      default() {
        return !!this.$options.$$s('enableTerms', false)
      }
    },
    terms: {
      default() {
        return this.$options.$$s(
          'form.fields.terms.urls.terms.url',
          this.$options.$$s('termsUrl') ||
          this.$options.$$s('terms.url', '')
        )
      }
    },
    privacy: {
      default() {
        return this.$options.$$s(
          'form.fields.terms.urls.privacy.url',
          this.$options.$$s('privacyUrl') ||
          this.$options.$$s('privacy.url', '')
        )
      }
    },
    enableSubscribeConfirmer: {
      default() {
        return !!this.$options.$$s('enableSubscribeConfirmer', false)
      }
    },
    includeSmsSubscribe: {
      default() {
        return !!this.$options.$$s('includeSmsSubscribe', false)
      }
    },
    subscribeLabel: {
      default() {
        return this.$options.$$t('form.fields.subscribe.label', defaultContent.subscribe.label)
      }
    }
  },
  data() {
    return {
      now: now.toISODate(),
      termsUrl: null,
      privacyUrl: null,
      showConfirmSubscribe: false,
      deniedSubscription: false,
      registrationError: '',
      isSubmitting: false,
      isFormDisabled: false,
      createdEmail: null,
      successResend: false,
      resendCount: -1,
      fields: {
        first_name: '',
        last_name: '',
        clubspeed_racername: null,

        email: null,
        email_confirmation: null,

        password: null,
        password_confirmation: null,

        gender: null,
        birth_date: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: 'US',

        phone: null,
        phone_confirmation: null,
        clubspeed_discovery: 0,

        subscribe: false,
        sms_subscribe: null,
        terms: false,
      },
      sources: {
        countries,
        states,
        // howDoYouKnow: config.clubspeed.sources,
      },
      validations: parseValidationSetup(validations, this),
      showFormLabels: true,
    }
  },
  validations: {fields: parseValidations(validations)},
  mounted() {
  },
  created() {
    // window.skipGlobalTimerMessage = true
    this.termsUrl = this.terms || '/terms-of-use'
    this.privacyUrl = this.privacy || '/privacy-policy'

    if (!this.enableTerms) {
      this.fields.terms = true
    }
    if (this.includeSmsSubscribe) {
      this.fields.sms_subscribe = this.fields.subscribe
    }
  },
  watch: {
    'fields.subscribe': function (value) {
      if (this.includeSmsSubscribe) {
        this.fields.sms_subscribe = value
      }
      if (value && this.showConfirmSubscribe) {
        this.showConfirmSubscribe = false
      }
    }
  },
  computed: {

    hasSelectedSubscribe() {
      return this.fields.subscribe
    },
    canShowConfirmSubscribe() {
      return this.enableSubscribeConfirmer &&
        this.showConfirmSubscribe &&
        !this.deniedSubscription &&
        !this.hasSelectedSubscribe
    }
  },
  methods: {
    $$dt(path) {
      return _.get(defaultContent, path)
    },
    getFieldLabel(fieldName, defaultValue = '', fieldsPath = 'fields', forceShow) {
      const pathPrefix = 'form.' +  (fieldsPath ? `${fieldsPath}.` : '') + fieldName
      const canShow = this.$$fv(
        forceShow,
        this.$$s(`${pathPrefix}.showLabel`, null),
        this.showFormLabels !== false
      )
      if (canShow) {
        return this.$$t(`${pathPrefix}.label`, defaultValue)
      }
      return ''
    },
    async resendConfirmation() {
      const email = this.createdEmail
      this.isSubmitting = true
      this.successResend = false
      try {
        const data = await MainService.sendConfirmation({email})
        this.resendCount++
        this.successResend = true
      } catch (e) {
        this.alert(MainService.getFirstErrorMessage(e))
      }
      this.isSubmitting = false
    },
    showConfirmation() {
      this.createdEmail = this.fields.email
    },
    async confirmSubscribeAndRegister() {
      this.deniedSubscription = false
      this.fields.subscribe = true
      if (this.includeSmsSubscribe) {
        this.fields.sms_subscribe = true
      }
      this.showConfirmSubscribe = false
      await this.registerNow()
    },
    async denySubscribeAndRegister() {
      this.deniedSubscription = true
      this.fields.subscribe = false
      if (this.includeSmsSubscribe) {
        this.fields.sms_subscribe = false
      }
      this.showConfirmSubscribe = false
      await this.registerNow()
    },
    async registerNow() {
      await this.$nextTick()
      this.$v.$touch()
      this.formSubmitting = true
      const publicFields =_.omit(_.clone(this.fields), ['password', 'password_confirmation'])
      EventBus.$emit('user.registration.before', publicFields)

      if (this.isAnyInvalid) {
        this.scrollToFirstErrorElement()
        return;
      }
      if (this.enableSubscribeConfirmer && !this.hasSelectedSubscribe && !this.deniedSubscription) {
        this.showConfirmSubscribe = true
        return;
      }

      this.registrationError = ''
      this.isSubmitting = true
      this.isFormDisabled = true
      const {fields} = this
      let result = {}
      try {
        result = await ProviderService.register(fields)
      } catch (e) {
        this.registrationError = ProviderService.getFirstErrorMessage(e) || 'Ops! unable to register! Please try again.'
        this.isFormDisabled = false
      }

      if (!this.registrationError) {

        if (result.success) {

          result.email = fields.email
          let redirect = this.loginRedirect

          if (redirect === 'page-checkout' || redirect === 'page-cart') {

            this.saveToken({
              token: result.access_token
            })
            try {
              await this.fetchUser()
            } catch (error) {

              this.registrationError = error.response.data.message
              this.isFormDisabled = false
            }

            this.setPostLoginPage(null)
            this.setIsPreCheckoutRegistration(true)
            this.goto(redirect)

          } else {
            this.showConfirmation()
          }

        } else {
          this.registrationError = result.error
          this.isFormDisabled = false
        }
      }

      this.showConfirmSubscribe = false
      this.deniedSubscription = false
      this.isSubmitting = false
      this.scrollTo(get$('.page-registration'))
    }
  }
}
